import { createSelector } from 'reselect';
import { fulfilled, pending, rejected } from './constants';

export const isLoaded = (statusSelector: any) => (state: any, props?: any) =>
  statusSelector(state, props) === fulfilled;

export const isRejected = (statusSelector: any) => (state: any) =>
  statusSelector(state) === rejected;

export const isPending = (statusSelector: any) => (state: any) =>
  statusSelector(state) === pending;

export const shouldLoad = (statusSelector: any) =>
  createSelector(
    statusSelector,
    (status: string) =>
      status !== pending && status !== fulfilled && status !== rejected,
  );
